import { ModalScreenProps, ModalScreens } from 'components/Navigation/types';
import { Page } from 'components/Page';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useConfirmUnsaved } from 'hooks/useConfirm';
import { Card } from 'components/Card';
import { TextAreaField } from 'components/Field/TextAreaField/TextAreaField';
import { doAseUnsubmit, NAVIGATE_MODAL_BACK } from 'store/actions';
import { useEsc } from 'hooks/useEsc';
import { CardRow } from 'components/CardRow';
import { PageHeader } from 'components/PageHeader';

export const StatusUnsubmitModal: React.FC<
  ModalScreenProps<ModalScreens.AseStatusUnsubmit>
> = ({ navigation }) => {
  const dispatch = useDispatch();
  const confirmUnsaved = useConfirmUnsaved();

  const [notify, setNotify] = React.useState(true);
  const [note, setNote] = React.useState('');

  const handleClose = () => {
    if (note) {
      confirmUnsaved({
        onSave: handleSave,
        onDiscard: () => dispatch(NAVIGATE_MODAL_BACK()),
      });
      return;
    }
    dispatch(NAVIGATE_MODAL_BACK());
  };

  const handleSave = () =>
    dispatch(
      doAseUnsubmit({
        notify,
        note,
      }),
    );

  React.useEffect(() => {
    navigation?.setOptions({ gestureEnabled: !note });
  }, [navigation, note]);
  useEsc(handleClose);

  return (
    <Page
      scrollView
      header={
        <PageHeader
          title="Assessment"
          onPressCancelButton={handleClose}
          onPressSaveButton={note.trim() ? handleSave : null}
          saveButtonText="Unsubmit"
        />
      }
    >
      <Card
        label="Reason"
        required
        explanation="Explain why you're unsubmitting this assessment. Your reason will be displayed in the assessment's history"
      >
        <TextAreaField onChange={setNote} value={note} onEsc={handleClose} />
      </Card>
      <Card
        explanation={
          notify
            ? 'RiskBase will email the assessor with the reason, letting them know the assessment has been unsubmitted'
            : 'RiskBase will not email the assessor'
        }
      >
        <CardRow
          label="Notify Assessor"
          switchValue={notify}
          onSwitchChange={() => setNotify(!notify)}
        />
      </Card>
    </Page>
  );
};
